import React from "react";
import { Routes, Route, Navigate } from "react-router";
import LandingPage from "./LandingPage";
import ResetPassword from "./ResetPassword";
import ValidateEmail from "./ValidateEmail";
import { ROUTES } from "routes";

const LandingRouter: React.FC = () => {
    return (
        <Routes>
            <Route path="login" element={<LandingPage webUrl={ROUTES.LOGIN} mobileUrl="twoghether://login" />} />
            <Route path="reset-password/:token" element={<ResetPassword />} />
            <Route path="validate-email/:token" element={<ValidateEmail />} />
            <Route path="*" element={<Navigate to={ROUTES.HOME} />} />
        </Routes>
    );
};

export default LandingRouter;
